export default __webpack_public_path__ + "static/media/016-stopwatch.0541257d.svg";